import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PrivacyView from '../views/PrivacyView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { title: 'Soda Connect Easy App for Secure Connection' },
    component: HomeView,
  },
  {
    path: '/privacy',
    name: 'privacy',
    meta: { title: 'Soda Connect Easy App for Secure Connection |  Privacy Policy' },
    component: PrivacyView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Сохраненная позиция (кнопка "назад")
    if (savedPosition) {
      return savedPosition
    }

    // Обработка якорей
    if (to.hash) {
      // Для Safari может потребоваться отложить прокрутку
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: 'smooth',
            top: 20 // отступ сверху (если нужен)
          })
        }, 100) // небольшая задержка для Safari
      })
    }

    // Для всех остальных случаев - наверх
    return { top: 0 }
  }
})

router.afterEach(to => {
  // Используем название из meta, а если его нет — подставляем запасное
  document.title = to.meta.title || 'Soda Connect Easy App for Secure Connection'
})

export default router
